// Project Imports
import ModuleIdentifierConst from 'core/common/moduleIdentifier';
import resourceName from 'core/common/resourceName';
import ResourceItem from 'interfaces/resource';

const img = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.8125 16.25H17.1875M2.8125 16.25C2.29473 16.25 1.875 15.8303 1.875 15.3125M2.8125 16.25H9.0625C9.58027 16.25 10 15.8303 10 15.3125M1.875 15.3125V4.6875M1.875 15.3125V14.0625C1.875 13.5447 2.29473 13.125 2.8125 13.125M18.125 15.3125V4.6875M18.125 15.3125C18.125 15.8303 17.7053 16.25 17.1875 16.25M18.125 15.3125V14.0625C18.125 13.5447 17.7053 13.125 17.1875 13.125M17.1875 16.25H10.9375C10.4197 16.25 10 15.8303 10 15.3125M18.125 4.6875C18.125 4.16973 17.7053 3.75 17.1875 3.75H2.8125C2.29473 3.75 1.875 4.16973 1.875 4.6875M18.125 4.6875V5.9375C18.125 6.45527 17.7053 6.875 17.1875 6.875M1.875 4.6875V5.9375C1.875 6.45527 2.29473 6.875 2.8125 6.875M2.8125 6.875H17.1875M2.8125 6.875H9.0625C9.58027 6.875 10 7.29473 10 7.8125M2.8125 6.875C2.29473 6.875 1.875 7.29473 1.875 7.8125V9.0625C1.875 9.58027 2.29473 10 2.8125 10M17.1875 6.875H10.9375C10.4197 6.875 10 7.29473 10 7.8125M17.1875 6.875C17.7053 6.875 18.125 7.29473 18.125 7.8125V9.0625C18.125 9.58027 17.7053 10 17.1875 10M2.8125 10H9.0625M2.8125 10C2.29473 10 1.875 10.4197 1.875 10.9375V12.1875C1.875 12.7053 2.29473 13.125 2.8125 13.125M10 9.0625V7.8125M10 9.0625C10 9.58027 9.58027 10 9.0625 10M10 9.0625C10 9.58027 10.4197 10 10.9375 10M9.0625 10C9.58027 10 10 10.4197 10 10.9375M10.9375 10H17.1875M10.9375 10C10.4197 10 10 10.4197 10 10.9375M17.1875 10C17.7053 10 18.125 10.4197 18.125 10.9375V12.1875C18.125 12.7053 17.7053 13.125 17.1875 13.125M2.8125 13.125H9.0625M10 12.1875V10.9375M10 12.1875C10 12.7053 9.58027 13.125 9.0625 13.125M10 12.1875C10 12.7053 10.4197 13.125 10.9375 13.125M9.0625 13.125C9.58027 13.125 10 13.5447 10 14.0625M10 15.3125V14.0625M10 14.0625C10 13.5447 10.4197 13.125 10.9375 13.125M10.9375 13.125H17.1875"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CommunicationResource: ResourceItem = {
  name: resourceName.templateDetails,
  identifier: ModuleIdentifierConst.COMMUNICATION,
  list: `${resourceName.templateDetails}`,
  show: `${resourceName.templateDetails}/show/:id`,
  create: `${resourceName.templateDetails}/create`,
  edit: `${resourceName.templateDetails}/edit/:id`,
  options: { label: 'CommunicationHub', icon: img },
};

export default CommunicationResource;
